export const APP_VERSION = "1.0.0";
export const ip = "https://carbonspace.com.ua";
//export const ip = "http://192.168.0.112:21111";
//export const ip = "http://192.168.1.121:21111";